'use client'
import * as React from 'react'

import { useLocalization } from '../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { intlPrettyCurrency } from '../../../lib/utils'

import { IProps } from './IProps'
import { CrossedOutPrice, DiscountPrice, Price, ValuePrice } from './styles'

export const PriceDisplay: React.FC<IProps> = ({
  discountPrice,
  displayDiscountAsValue,
  discountPriceExplicitFmt,
  price,
  priceExplicitFmt,
  priceRange,
  pgDiscountPriceRange,
}) => {
  const { locale, region } = useLocalization()
  const { valueSignalLabel } = useTranslation().collections.productGroupTile
  const formattedPrice =
    priceExplicitFmt ??
    intlPrettyCurrency({ unit: 'cents', value: price, region: region, locale: locale })

  if (pgDiscountPriceRange && pgDiscountPriceRange.min !== pgDiscountPriceRange.max) {
    if (pgDiscountPriceRange.max === price) {
      return (
        <>
          <DiscountPrice>
            {intlPrettyCurrency({
              unit: 'cents',
              value: pgDiscountPriceRange.min,
              region: region,
              locale: locale,
            })}
          </DiscountPrice>{' '}
          <Price>
            {'- '} {formattedPrice}
          </Price>
        </>
      )
    }
    return (
      <>
        <DiscountPrice>
          {intlPrettyCurrency({
            unit: 'cents',
            value: pgDiscountPriceRange.min,
            region: region,
            locale: locale,
          })}
          {' - '}
          {intlPrettyCurrency({
            unit: 'cents',
            value: pgDiscountPriceRange.max,
            region: region,
            locale: locale,
            explicitFormat: true,
          })}
        </DiscountPrice>{' '}
        <CrossedOutPrice>{formattedPrice}</CrossedOutPrice>
      </>
    )
  } else if (priceRange) {
    return (
      <>
        <Price>
          {intlPrettyCurrency({
            unit: 'cents',
            value: priceRange.min,
            region: region,
            locale: locale,
          })}
        </Price>
        -{' '}
        <Price>
          {intlPrettyCurrency({
            unit: 'cents',
            value: priceRange.max,
            region: region,
            locale: locale,
          })}
        </Price>
      </>
    )
  }

  if (discountPrice && (!price || (!!price && discountPrice < price))) {
    return (
      <>
        <DiscountPrice $displayDiscountAsValue={displayDiscountAsValue}>
          {discountPriceExplicitFmt ??
            intlPrettyCurrency({
              unit: 'cents',
              value: discountPrice,
              region: region,
              locale: locale,
            })}
        </DiscountPrice>{' '}
        {!!price &&
          (displayDiscountAsValue ? (
            <ValuePrice>
              ({formattedPrice} {valueSignalLabel})
            </ValuePrice>
          ) : (
            <CrossedOutPrice>{formattedPrice}</CrossedOutPrice>
          ))}
      </>
    )
  }

  if (!price) return null

  return <Price>{formattedPrice}</Price>
}
